const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'https://fitnessecrets.com/php-api').replace(/\/$/, '');

/**
 * Converts a DB image path (e.g. "assets/images/team/faten.jpeg")
 * to a full URL served from the PHP API server.
 * Absolute URLs and paths that already start with "/" are returned unchanged.
 */
export const getImageUrl = (path) => {
  if (!path) return null;
  if (
    path.startsWith('http://') || path.startsWith('https://') ||
    path.startsWith('/') || path.startsWith('data:') || path.startsWith('blob:')
  ) return path;
  return `https://fitnessecrets.com/${path}`;
};

const toQuery = (params) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

export const getBlogs = ({ lang = 'en', category = 'all', page = 1, limit = 4, search = '' } = {}) =>
  fetch(`${API_BASE}/blogs/list.php?${toQuery({ lang, category, page, limit, search })}`).then(r => r.json());

export const getCategories = ({ lang = 'en' } = {}) =>
  fetch(`${API_BASE}/blogs/categories.php?${toQuery({ lang })}`).then(r => r.json());

export const getBlogBySlug = ({ lang = 'en', slug } = {}) =>
  fetch(`${API_BASE}/blogs/detail.php?${toQuery({ lang, slug })}`).then(r => r.json());

export const getRelatedBlogs = ({ lang = 'en', blogId, categoryId, limit = 3 } = {}) =>
  fetch(`${API_BASE}/blogs/related.php?${toQuery({ lang, blog_id: blogId, category_id: categoryId, limit })}`).then(r => r.json());

export const getTags = ({ lang = 'en' } = {}) =>
  fetch(`${API_BASE}/blogs/tags.php?${toQuery({ lang })}`).then(r => r.json());
